import i18n from 'i18next';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;

/**-----------------------------------------------------------------------------
 * Redirect Payment Form
 */
UI.View({
    name: 'order_online_payment_redirect_form',
    model: Order,
    model_listeners: {
        updateProgressPhase: 'updateProgressPhase',
        updatePaymentProcessorRedirectUrl: 'shouldPromptToRedirect',
        syncSuccess: 'syncSuccess',
    },
    updateProgressPhase() {
        const processor = Order.getPaymentProcessor();
        const phase = Order.getProgressPhase();
        if (
            phase === 'confirming' &&
            processor &&
            processor.form_type === 'redirect' &&
            processor.getUrl()
        ) {
            this.dirty = true;
        }
    },
    syncSuccess() {
        if (this.dirty === true) {
            this.shouldPromptToRedirect();
        }
        this.dirty = false;
    },
    shouldPromptToRedirect() {
        const processor = Order.getPaymentProcessor();
        const phase = Order.getProgressPhase();
        if (
            phase === 'confirming' &&
            processor &&
            processor.form_type === 'redirect' &&
            processor.getUrl()
        ) {
            this.promptToRedirectToPaymentPage();
        }
    },
    promptToRedirectToPaymentPage() {
        setTimeout(() => {
            UI.centeredAlert({
                title: i18n.t(
                    'order.online-payment.redirect-form:redirect_to_payment_page_title'
                ),
                body: i18n.t(
                    'order.online-payment.redirect-form:redirect_to_payment_page_body'
                ),
                primary_button: i18n.t(
                    'order.online-payment.redirect-form:redirect_to_payment_page_primary_button'
                ),
                secondary_button: i18n.t(
                    'order.online-payment.redirect-form:redirect_to_payment_page_secondary_button'
                ),
                onPrimaryButtonClick() {
                    window.location = Order.getPaymentProcessor().getUrl();
                },
                onSecondaryButtonClick() {
                    Order.cancelConfirmation();
                },
            });
        }, 100);
    },
});
